const circularprocesstype = {
    getlist: 'circularprocesstype/getlist',
    add: 'circularprocesstype/add',
    update: 'circularprocesstype/update',
    remove: 'circularprocesstype/remove',
    get: 'circularprocesstype/get',
    getall: 'circularprocesstype/getall',
    clearcache: 'circularprocesstype/clear-cache',
}
export default circularprocesstype
